import {combineLatest as observableCombineLatest, of as observableOf, Observable} from 'rxjs';
import {first} from 'rxjs/operators';
import {ResourceWithPermissionHints} from './resource';
import {CacheService} from '../cache/cache.service';
import {EnvironmentConfigService} from '../core/services/environment-config.service';
import {LanguageService} from '../language/language.service';

// Standalone helper so detail components do not have to import ResourceComponent,
// which would create a circular dependency with the classes extending
// ResourceDetailAbstractComponent.
export function getResourceLabel(
  resource: ResourceWithPermissionHints,
  cacheService: CacheService,
  envConfig: EnvironmentConfigService,
): Observable<string> {
  if (resource == null) {
    return observableOf('');
  }
  if (
    resource[envConfig.getAttributeName('DisplayName')] != null &&
    resource[envConfig.getAttributeName('DisplayName')].Values != null &&
    resource[envConfig.getAttributeName('DisplayName')].Values.trim().length != 0
  ) {
    return observableOf(resource[envConfig.getAttributeName('DisplayName')].Values);
  }

  //Add title because of caption
  return observableCombineLatest(
    cacheService.getLanguageResource().pipe(first()),
    cacheService.getDisplayAttribute(
      envConfig.getAttributeName('DisplayName'),
      resource[envConfig.getAttributeName('ObjectType')].Values,
    ),
    (strRes, caption) => {
      if (caption != null && strRes != null) {
        return (
          '⟨ ' +
          LanguageService.translate('DatatableNo', 'No', strRes) +
          ' ' +
          caption.Caption +
          ' ⟩'
        );
      }
      return '⟨ Unknown ⟩';
    },
  );
}
